module.exports = __webpack_public_path__ + "static/media/icon-aluguel-redimento.dc478a73.webp";